<template>
  <v-expansion-panels class="mt-2 pa-2">
    <v-expansion-panel>
      <v-expansion-panel-header class="expansion--panel">
        <v-row no-gutters>
          <v-col cols="8"><v-icon color="white">mdi-history</v-icon> {{ $t('message.orders.history') }}</v-col>
          <v-col cols="4" class="text-right"><v-btn dark outlined text small :loading="loadingHis" @click.stop="refreshHistory"><v-icon color="white">mdi-history</v-icon> {{ $t('message.common.reload') }}</v-btn></v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pt-2">
        <template v-if="listOfHistories && listOfHistories.length > 0">
          <v-form ref="addonsForm">
            <v-container fluid class="pa-0">
              <v-simple-table dense class="elevation-1 bordered--table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="15%">{{ $t('message.tickets.createdOn') }}</th>
                      <th width="15%">{{ $t('message.orders.createdBy') }}</th>
                      <th width="30%">{{ $t('message.layout.status') }}</th>
                      <th width="15%">{{ $t('message.layout.orderOrOffer') }}</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in listOfHistories" :key="item.id">
                      <td>{{ item.createdon | dateTimeFormat }}</td>
                      <td>{{ item.firstname || '' }}</td>
                      <td v-if="item.iscommercialinvoice === true"><a @click="$emit('downloadInvoice', 4, item.id)">{{ item.state }}</a></td>
                      <td v-else>{{ item.state }}</td>
                      <td>
                        <a v-if="item.saleid" :href="`/orders/edit/${item.saleid}/view`">{{ item.order_number }}</a>
                      </td>
                      <td>
                        <v-btn v-if="item.documentspid" color="primary" icon @click="downloadHandler(index, item.documentspid)" :loading="item.loading">
                          <v-icon>mdi-cloud-download</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-container>
          </v-form>
        </template>
        <v-alert prominent text v-else type="info" class="mt-2" >
          <v-row align="center">
            <v-col class="grow">{{ $t('message.common.no_records') }}</v-col>
          </v-row>
        </v-alert>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
export default {
  props: ['listOfHistories', 'loadingHis'],
  methods: {
    downloadHandler (index, id) {
      this.$set(this.listOfHistories, index, { ...this.listOfHistories[index], loading: true })
      this.$_executeApi('get', `sharepoint/download/${id}`)
        .then((response) => {
          this.$set(this.listOfHistories, index, { ...this.listOfHistories[index], loading: false })
          window.open(`${process.env.VUE_APP_URL}file/download?fileName=${response.data}`, '_blank')
        })
    },
    refreshHistory () {
      this.$eventBus.$emit('loadHistory')
    }
  }
}
</script>
